<template>
  <mHeader name="投诉建议" />
  <div class="complaint-add-button">
    <Button icon="plus" type="primary" block size="small" @click="() => router.push('/user/complaint/add')">我要投诉</Button>
  </div>
  <mLongList :getData="getComplaintList" type="complaint" :params="params" />
</template>

<script>
import { getComplaintList } from '@/api/complaint'
import { useStore } from 'vuex'
import { Button } from 'vant'
import { useRouter } from 'vue-router'

import 'vant/es/button/style'

export default {
  components: { Button },
  setup (props) {
    const router = useRouter()
    const store = useStore()
    const params = {
      user_id: store.state.user.userId
    }

    return {
      getComplaintList,
      params,
      router
    }
  }
}
</script>
